// src/components/ErrorBoundary.jsx
import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props){ super(props); this.state = { hasError:false, info:null }; }
  static getDerivedStateFromError(){ return { hasError:true }; }
  componentDidCatch(error, info){ console.error('[UI CRASH]', error, info); this.setState({ info }); }

  render(){
    if (this.state.hasError){
      return (
        <div style={{padding:16}}>
          <h2>Något gick fel i vyn</h2>
          <p>Prova att uppdatera sidan. Om felet kvarstår, kontakta support.</p>
          <button onClick={()=>window.location.assign('/dashboard')}>Till dashboard</button>
        </div>
      );
    }
    return this.props.children;
  }
}
